import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="section-progress"
// アコーディオンのセクション内で入力が変わるたびに、必須項目の入力数(n/m)バッジを数え直す。
// 初期表示と保存後の再描画はサーバーで計算した値(Company::WelboxCompletionChecker.filled?)を表示し、
// このコントローラは入力中の表示だけを担う。
// NOTE: 入力済みの判定は Company::WelboxCompletionChecker.filled? と揃えること(片方だけ変えない)
export default class extends Controller {
  static targets = ["badge"]
  static values = { fields: Array } // 必須項目のフォーム上のname(複数選択の末尾の [] は付けない)
  static classes = ["complete"]

  update() {
    if (!this.hasBadgeTarget) return

    const total = this.fieldsValue.length
    const filled = this.fieldsValue.filter((name) => this.isFilled(name)).length

    this.badgeTarget.textContent = `${filled}/${total}`
    this.badgeTarget.classList.toggle(this.completeClass, filled === total)
  }

  // 未入力: 空文字・未選択・「設定なし」(value="")のラジオ・選択の無い複数選択
  isFilled(name) {
    const elements = Array.from(this.element.querySelectorAll(`[name="${name}"], [name="${name}[]"]`))

    return elements.some((el) => {
      // 複数選択の「全て外した」を送るための空文字の隠しフィールドは数えない
      if (el.type === "hidden") return false
      if (el.type === "radio" || el.type === "checkbox") return el.checked && el.value !== ""
      if (el.multiple) return Array.from(el.selectedOptions).some((option) => option.value !== "")

      return el.value !== ""
    })
  }
}
